import Vue from 'vue'
// 空Vue实例作为全局事件发布/订阅中心
const Bus = new Vue()
export default Bus
